// ✅ v3.8.9 — Multi-Toggle Scroll Lock with Delegation (Shopify Safe)
document.addEventListener('DOMContentLoaded', () => {
// console.log('[CLUG FILTERS] Quick Filter Script Running');  
  // 🔥 STEP 1: Restore scroll from previous toggle
const savedScroll = sessionStorage.getItem('restoreScrollY');
if (savedScroll !== null && Shopify.template === 'collection') {
  window.scrollTo(0, parseInt(savedScroll));
  sessionStorage.removeItem('restoreScrollY');
}

  
  // 🔧 STEP 2: Initialize Toggle Map for sync
  const toggles = document.querySelectorAll('.clug-qf-toggle');
  const toggleMap = new Map();

  toggles.forEach(toggle => {
    const param = toggle.dataset.toggleParam;
    const value = toggle.dataset.toggleValue;
    const inputEl = toggle.querySelector('input[type="checkbox"]');
    const key = `${param}|${value}`;

    if (!toggleMap.has(key)) toggleMap.set(key, []);
    toggleMap.get(key).push({ toggle, inputEl });

    const urlParams = new URLSearchParams(window.location.search);
    const isActive = urlParams.getAll(param).includes(value);

    if (isActive) {
      toggle.classList.add('clug-qf-toggle--active');
      if (inputEl) inputEl.checked = true;
    }
  });

  // 🧠 STEP 3: Scroll-safe toggle handling via delegation
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('.clug-qf-toggle');
    if (!toggle) return;

    e.preventDefault();

    const scrollTop = window.scrollY;

    sessionStorage.setItem('restoreScrollY', scrollTop);

    const param = toggle.dataset.toggleParam;
    const value = toggle.dataset.toggleValue;

    const nativeCheckbox = document.querySelector(
      `input[type="checkbox"][name="${param}"][value="${value}"]`
    );

    if (nativeCheckbox) {
      nativeCheckbox.click(); // ✅ Let Shopify handle the reload
    }
  });

  // ♻️ Utility: Sync toggle visual states
  function updateQuickToggleState(param, value, isChecked) {
    const key = `${param}|${value}`;
    const entries = toggleMap.get(key);
    if (!entries) return;

    entries.forEach(({ toggle, inputEl }) => {
      if (isChecked) {
        toggle.classList.add('clug-qf-toggle--active');
        if (inputEl) inputEl.checked = true;
      } else {
        toggle.classList.remove('clug-qf-toggle--active');
        if (inputEl) inputEl.checked = false;
      }
    });
  }

  // 🧹 Clear filters button support
document.body.addEventListener('click', (e) => {
  const nativeClear = e.target.closest('.facets__clear, [data-action="clear-filters"], button[type="reset"]');
  if (!nativeClear) return;

  // ✅ Save scroll BEFORE Shopify clears filters
  const scrollTop = window.scrollY;
  sessionStorage.setItem('restoreScrollY', scrollTop);


  // ✅ Reset toggle visuals now
toggleMap.forEach((entries) => {
  entries.forEach(({ toggle, inputEl }) => {
    if (toggle) toggle.classList.remove('clug-qf-toggle--active');
    if (inputEl) inputEl.checked = false;
  });
});

  // 🧠 Wait for DOM to mutate
  const filterContainer = document.querySelector(
    '#FacetFiltersForm, .facets, .filters, .collection-filters, .filter-group'
  );

  if (!filterContainer) return;

  const observer = new MutationObserver((mutationsList, observerRef) => {
    syncAllToggles();
    observerRef.disconnect();
  });

  observer.observe(filterContainer, {
    childList: true,
    subtree: true,
  });
});


  // 🔄 Listen for checkbox changes (e.g. Shopify reloads or URL param clicks)
document.addEventListener('change', (e) => {
  const el = e.target;

  // 🧠 Save scroll if it's a native Shopify filter input
  if (
    el.matches('input[type="checkbox"], input[type="radio"], select') &&
    el.closest('#FacetFiltersForm, .facets, .filters, .collection-filters, .filter-group')
  ) {
    const scrollTop = window.scrollY;
    sessionStorage.setItem('restoreScrollY', scrollTop);

  }

  // 🔁 Also update quick toggle visual state if applicable
  if (el.matches('input[type="checkbox"]')) {
    const param = el.name;
    const value = el.value;
    const isChecked = el.checked;
    updateQuickToggleState(param, value, isChecked);
  }
});
  
// ♻️ DOM watch for Shopify's async content changes
const container = document.querySelector('main') || document.body;

if (container) {
  const observer = new MutationObserver((mutations) => {
    const savedScroll = sessionStorage.getItem('restoreScrollY');

    // ✅ Only restore once
    if (savedScroll !== null) {
      window.scrollTo(0, parseInt(savedScroll));
      sessionStorage.removeItem('restoreScrollY'); // 💥 This stops it from repeating

    }

    setTimeout(syncAllToggles, 150);
  });

  observer.observe(container, {
    childList: true,
    subtree: true,
  });
}

  function syncAllToggles() {
    toggleMap.forEach((entries, key) => {
      const [param, value] = key.split('|');
      const checkbox = document.querySelector(
        `input[type="checkbox"][name="${param}"][value="${value}"]`
      );
      const isChecked = checkbox?.checked || false;
      updateQuickToggleState(param, value, isChecked);
    });
  }
});